/*
  # Accordion Viewport Limit

  The data-accordion-active-where attribute determines viewports
  at which the element behaves as an accordion. For example:
    data-accordion-active-where="(max-width: 799px)"
  will cause the element to not behave as an accordion at 800
  pixels and above.

*/

import { debounce } from '../api/debounce'

import { assignController, getControllers, controllersAvailable } from '../api/element-manipulation'

assignController('accordionViewportLimit', (element) => {
  let active = false
  const outer = element.querySelector('[data-hook~="accordion.outer"]')
  const activeWhere = element.dataset.accordionActiveWhere
  const determineActive = () => {
    active = window.matchMedia(activeWhere).matches
    if ( active ) {
      outer.setAttribute('aria-expanded', (element.dataset.accordionExpanded === '1') ? 'true' : 'false')
    } else {
      outer.setAttribute('aria-expanded', 'true')
    }
  }
  const onOpened = event => {
    if ( !active ) {
      event.preventDefault()
    }
  }
  window.addEventListener('resize', debounce(determineActive, 200))
  controllersAvailable(
    () => {
      const accordion = getControllers(element).accordion
      accordion.opened.push(onOpened)
      determineActive()
    }
  )
})